import { useSelector } from "react-redux";
import { Box } from "@remo-co/ui-core";
import classNames from "classnames";
import { isEventManager } from "modules/event/utils/eventUtils";
import { selectCurrentEvent } from "modules/event/selectors";
import useCompanySettingsState from "modules/companySettings/hooks/useCompanySettingsState";
import useLoginRole from "modules/auth/hooks/useLoginRole";
import { IUser } from "modules/app/types";
import { ReactComponent as PictureIcon } from "../assets/picture.inline.svg";
import { useStyles } from "./styles";

interface IBadgePreviewProps {
  badgeUrl?: string;
  size: string;
  user?: IUser;
  isCompanyBadgeEdit?: boolean;
}

const BadgePreview = ({
  badgeUrl,
  size,
  user,
  isCompanyBadgeEdit,
}: IBadgePreviewProps) => {
  const classes = useStyles();
  const { enableCompanyBadge, companyBadgeURL } = useCompanySettingsState();
  const { isCompanyOwner } = useLoginRole();
  const currentEvent = useSelector(selectCurrentEvent);
  const isInEvent = !!currentEvent;
  // need to pass user id otherwise it's showing for badge for all manager not for specific company
  const isCompanyManager = isEventManager(currentEvent ?? undefined, user?.id);
  const imageUrl = badgeUrl || companyBadgeURL;

  const isValidCompanyMember = isInEvent ? isCompanyManager : isCompanyOwner;

  // check for showing badge only to company members
  const isCompanyBadgeVisible =
    isValidCompanyMember && (isCompanyBadgeEdit || enableCompanyBadge);

  if (!isCompanyBadgeVisible) {
    return null;
  }

  return (
    <Box
      data-testid="badge-preview-container"
      className={classNames(
        classes.badgePreview,
        classes[`badgePreview${size.toUpperCase()}`],
      )}
    >
      {(!imageUrl && <PictureIcon />) || (
        <img
          className={classes[`uploadedImage${size.toUpperCase()}`]}
          src={imageUrl}
          alt="Company Badge"
        />
      )}
    </Box>
  );
};

export default BadgePreview;
